import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { Wordmark } from "@/components/Wordmark";
import { HeroBackground } from "@/components/HeroBackground";
import { HOME } from "@/content";

// A welcoming entrance: curved lines and movement words come together over a
// soft royal-blue field while the logo assembles large at the centre, then the
// interface resolves gently into the homepage.
export function AnimatedLogoIntro({ onDone }) {
  const reduce = useReducedMotion();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const dur = reduce ? 400 : 3200;
    const t = setTimeout(() => { setVisible(false); setTimeout(onDone, 900); }, dur);
    return () => clearTimeout(t);
  }, [onDone, reduce]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="logo-intro"
          className="fixed inset-0 z-[200] flex items-center justify-center bg-ink-900"
          exit={{ opacity: 0, filter: "blur(6px)" }}
          transition={{ duration: 0.9, ease: [0.25, 1, 0.5, 1] }}
        >
          <HeroBackground />
          <div className="relative z-10 text-center px-6">
            <div className="relative mx-auto" style={{ width: "min(82vw, 620px)", aspectRatio: "1896 / 393" }}>
              <motion.div className="absolute inset-0 bg-no-repeat bg-contain" aria-label="I•AMovement"
                style={{ backgroundImage: "url(/media/logo.png)", backgroundPosition: "center", clipPath: "inset(0 50% 0 0)" }}
                initial={reduce ? { opacity: 0 } : { opacity: 0, x: -70, filter: "blur(6px)" }}
                animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                transition={{ duration: reduce ? 0.3 : 1.1, delay: reduce ? 0 : 0.3, ease: [0.25, 1, 0.5, 1] }} />
              <motion.div className="absolute inset-0 bg-no-repeat bg-contain"
                style={{ backgroundImage: "url(/media/logo.png)", backgroundPosition: "center", clipPath: "inset(0 0 0 50%)" }}
                initial={reduce ? { opacity: 0 } : { opacity: 0, x: 70, filter: "blur(6px)" }}
                animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                transition={{ duration: reduce ? 0.3 : 1.1, delay: reduce ? 0.05 : 0.5, ease: [0.25, 1, 0.5, 1] }} />
            </div>
            <div className="font-display text-ice/90 mt-8 text-xl sm:text-2xl md:text-3xl max-w-2xl mx-auto leading-snug space-y-1.5">
              {HOME.hookLines.map((line, i) => (
                <motion.p key={line} data-testid={`logo-intro-line-${i}`}
                  initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: reduce ? 0.1 : 1.5 + i * 0.28, duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
                >
                  {line}
                </motion.p>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default AnimatedLogoIntro;
